import enKurtajRilatojKunLaUniverso from './en_kurtaj_rilatoj';
import kurteno from './kurteno';
import najleto from './najleto';
import demandoDeLaVivo from './demando_de_la_vivo';
import cerealoj from './cerealoj';
import laTempo from './la_tempo';
import laSplitvundo from './la_splitvundo';
import laNuksoj from './la_nuksoj';
import ĝojo from './ĝojo';
import sciencaDisputo from './scienca_disputo';
import fortaArgumento from './forta_argumento';
import malnovaDomo from './malnova_domo';
import steloj from './steloj';
import laSuno from './la_suno';
import malnovaAfiŝo from './malnova_afiŝo';
import energioDeVarmo from './energio_de_varmo';
import kubetoj from './kubetoj';
import neojalaKokido from './neojala_kokido';
import bruAmuziloPorBeboj from './bru_amuzilo_por_beboj';
import kreaMetodo from './krea_metodo';
import laFortoDeKonvinko from './la_forto_de_konvinko';
import laDigno from './la_digno';
import laFliko from './la_fliko';
import laAkno from './la_akno';
import laArbostumpo from './la_arbostumpo';
import laŜtofpeco from './la_ŝtofpeco';
import laŜutro from './la_ŝutro';
import modAdorantinoj from './mod_adorantinoj';
import laAmo from './la_amo';
import laLignofajroEnarbara from './la_lignofajro_enarbara';
import fraktumo from '././fraktumo';
import laLeĝoDeNombroj from './la_leĝo_de_nombroj';
import akutaAngulo from './akuta_angulo';
import negativaNombro from './negativa_nombro';
import laGrandeco from './la_grandeco';
import fenestroAlLaMondo from './fenestro_al_la_mondo';
import laLakmuso from './la_lakmuso';
import laBildo from './la_bildo';
import laGipso from './la_gipso';
import laOro from './la_oro';
import laĈircaŭo from './la_ĉircaŭo';
import laAŭtuno from './la_aŭtuno';
import laVulkanoj from './la_vulkanoj';
import laNaskiĝoDeLaForto from './la_naskiĝo_de_la_forto';
import diversajVidmanieroj from './diversaj_vidmanieroj';
import laVertikalo from './la_vertikalo';
import laVarmo from './la_varmo';
import laLeĝoDeTutmondaAltriĝo from './la_leĝo_de_tutmonda_altriĝo';
import memoraĵoj from './memoraĵoj';

const verkoj = [
	enKurtajRilatojKunLaUniverso,
	kurteno,
	najleto,
	demandoDeLaVivo,
	cerealoj,
	laTempo,
	laSplitvundo,
	laNuksoj,
	ĝojo,
	sciencaDisputo,
	fortaArgumento,
	malnovaDomo,
	steloj,
	laSuno,
	malnovaAfiŝo,
	energioDeVarmo,
	kubetoj,
	neojalaKokido,
	bruAmuziloPorBeboj,
	kreaMetodo,
	laFortoDeKonvinko,
	laDigno,
	laFliko,
	laAkno,
	laArbostumpo,
	laŜtofpeco,
	laŜutro,
	modAdorantinoj,
	laAmo,
	laLignofajroEnarbara,
	fraktumo,
	laLeĝoDeNombroj,
	akutaAngulo,
	negativaNombro,
	laGrandeco,
	fenestroAlLaMondo,
	laLakmuso,
	laBildo,
	laGipso,
	laOro,
	laĈircaŭo,
	laAŭtuno,
	laVulkanoj,
	laNaskiĝoDeLaForto,
	diversajVidmanieroj,
	laVertikalo,
	laVarmo,
	laLeĝoDeTutmondaAltriĝo,
	memoraĵoj
];

export default verkoj;